<template>
  <div class="mkt-masked-input">
		<md-field
			:class="{ 'md-invalid': hasErrors, 'md-read-only': blReadOnly }"
		>
			<mkt-label v-if="txLabel" class="mkt-field__label" :txLabel="txLabel" :bl-required="blRequired"></mkt-label>
			<md-input
				v-mask="txMask"
				v-model="componentModel"
				:placeholder="!blReadOnly ? txPlaceholder : '-'"
				:disabled="blDisabled || blReadOnly"
				:type="tpInputType.type"
				:required="blRequired"
				:id="txId"
				@blur="validateField"
			></md-input>
			<span class="md-error" v-if="hasErrors">{{formValidationError || 'Campo obrigatório'}}</span>
		</md-field>
  </div>
</template>

<script>
import PropConfig from 'pojos/PropConfig'
import InputType from 'domains/InputType'

import mktInput from 'src/components/globals/mktInput/mktInput'
import { mask } from 'vue-the-mask'

export default {
	name: 'mkt-masked-input',
	components: {
		mktInput
	},
	directives: {
		mask
	},
	props: {
		txLabel: new PropConfig({ type: String }),
		txPlaceholder: new PropConfig({ type: String }),
		txMask: new PropConfig({ type: [String, Array] }),
		blRequired: new PropConfig({ type: Boolean, valueDefault: false }),
		blDisabled: new PropConfig({ type: Boolean }),
		blReadOnly: new PropConfig({ type: Boolean, required: false, valueDefault: false }),
		nrMaxlength: new PropConfig({ type: Number, valueDefault: 10 }),
		txId: new PropConfig({ type: String, required: false }),
		value: new PropConfig({ required: false })
	},
	data() {
		return {
			tpInputType: InputType.NUMBER,
			hasErrors: false,
			formValidationError: ''
		}
	},
	mounted() {
		const val = this.value
		this.$nextTick(() => {
			this.componentModel = val
		})
	},
	methods: {
		validateField() {
			this.$emit('blur')
			if (this.blRequired) {
				this.$nextTick(() => {
					this.hasErrors = !this.value
				})
			} else {
				this.hasErrors = false
			}
		}
	},
	computed: {
		componentModel: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	}
}
</script>
<style src="./mktMaskedInput.scss" lang="scss">

</style>
